/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface MachineChecklistCategory
 */
export interface MachineChecklistCategory {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    version?: number;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the MachineChecklistCategory interface.
 */
export function instanceOfMachineChecklistCategory(value: object): value is MachineChecklistCategory {
    return true;
}

export function MachineChecklistCategoryFromJSON(json: any): MachineChecklistCategory {
    return MachineChecklistCategoryFromJSONTyped(json, false);
}

export function MachineChecklistCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineChecklistCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachineChecklistCategoryToJSON(json: any): MachineChecklistCategory {
    return MachineChecklistCategoryToJSONTyped(json, false);
}

export function MachineChecklistCategoryToJSONTyped(value?: MachineChecklistCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'active': value['active'],
    };
}

